/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Yes
 * 
 * 1 = No
 * 
 * 2 = UnableToAdjust
 */
export enum Adjustment {
  Yes = 0,
  No = 1,
  UnableToAdjust = 2
}
